import {useEffect, useState} from 'react';

import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';


import { FilePreviewIcon } from './FilePreviewIcon';
import { GovermentIdDialog } from './GovermentIdDialog';

function EnhancedTableHead({tableHeaderList, documnetList, ...props}) { 
  tableHeaderList= [
    {
      id: 'id Photo',
      disablePadding: false,
      label: 'ID Photos',
    },
    {
      id: 'Govt ID',
      disablePadding: false,
      label: 'Govt. ID',
    },
    {
        id: 'idNumber',
        disablePadding: false,
        label: 'ID Number',
      },

      {
        id: 'edit_delete',
        numeric: true,
        disablePadding: false,
        label: '',
      }
  ];
  return (
    <TableHead>
      <TableRow>
        {tableHeaderList.map((headCell) => (
          <>
            <TableCell
              key={headCell.id}
              align={'left'}
              padding={'normal'}
              className={'bg-gray-100 min-w-[200px] '}
              sx={{ minWidth: '8rem', minHeight: '1.25rem', 'color': '#596C86', 'fontSize': '12px', 'font-weight': 500 }}
            >
              {headCell.label}
            </TableCell>
          </>

        ))}
      </TableRow>
    </TableHead>
  );
}



export const GovermentIdTableView = ({tableHeaderList, setDocumentList, documentList, ...props}) => {
  
  const handleDelete = (index) => {
    const updatedDocumentList = documentList.map((item, i) => 
      i == index ? 
        {
          id: item?.id || 0,
          idName: item?.idName || '',
          idNumber: item?.idNumber || '',
          uploadedImages: item?.uploadedImages,
          isActive: false
        } : item
    );
    setDocumentList(updatedDocumentList);
  };

  return (
    <>
      <Box sx={{ width: '100%', borderRadius: '0.75rem' }} className='px-8'>
        <Paper sx={{ width: '100%', mb: 2, borderRadius: '0.75rem' }}>
          <TableContainer sx={{ borderRadius: '0.75rem' }}>
            <Table
              aria-labelledby="tableTitle"
              size={'medium'}
              sx={{ minWidth: 200, borderRadius: '0.75rem' }}
            >
              <EnhancedTableHead
                headCells={tableHeaderList}
              />

              <TableBody>
              {documentList?.map((row, index) => {
                  const labelId = `enhanced-table-checkbox-${index}`;
                  if(row.isActive != undefined && !row.isActive) return ;

                  return (
                    <TableRow
                      hover
                      tabIndex={-1}
                      key={row.id}
                      sx={{ cursor: 'pointer' }}
                    >
                       <TableCell align="left"
                        component="th"
                        id={labelId}
                        scope="row"
                        padding="normal"
                        className="flex gap-2 justify-center">
                        <div className="flex flex-row justify-center gap-2 items-center">
                          <FilePreviewIcon
                            isDeleteEnabled={false}
                            height={'5rem'}
                            width={'5rem'}
                            selectedFile={[row?.uploadedImages ? row.uploadedImages[0] : null]}
                          />
                          <p className="flex justify-center h-full text-center">
                            {row?.uploadedImages?.length > 1 ? (`+ ${row.uploadedImages.length - 1}`) : ""}
                          </p>
                        </div>
                      </TableCell>
                      <TableCell align="left"> {row.idName} </TableCell>
                      <TableCell align="left"> {row.idNumber} </TableCell>
                      <TableCell align="left"> 
                      <div className="flex jusitfy-center gap-6 px-2">
                          <GovermentIdDialog
                            govermentId={documentList}
                            setGovermentId={setDocumentList}
                            index={index}
                            isEditing={true}
                          /> 
                        <img src="https://views.medibuddy.in/providerUi/assets/deleteIcon.svg"  onClick={() => handleDelete(index)}  style={{ cursor: 'pointer' }}  alt="Delete" />
                        </div>
                         </TableCell>
                     
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
      </Box>
    </>

  );
}